'use client';

import CloseIcon from '@mui/icons-material/Close';
import { Box, ButtonBase, Snackbar, Typography } from '@mui/material';
import Image from 'next/image';
import { useState } from 'react';

export const ErrorPopup = () => {
  const [open, setOpen] = useState(true);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      autoHideDuration={null}
      sx={{
        px: { xs: 2 },
        pt: { xs: 3, md: 1 },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          bgcolor: 'common.white',
          borderRadius: 1,
          boxShadow: '0px 1px 3px 0px #0000004D',
          pl: '20px',
          pr: 2,
          py: { xs: 2, sm: '12px' },
          borderLeft: '4px solid',
          borderColor: 'reds.main',
        }}
      >
        <Box sx={{ display: 'flex', alignSelf: 'flex-start' }}>
          <Image
            width={24}
            height={24}
            src="https://www.nerdwallet.com/cdn/banking/icons/alert-red.svg"
            alt="Error Alert"
            unoptimized
          />
        </Box>
        <Box sx={{ display: 'flex', whiteSpace: { xs: 'wrap', sm: 'nowrap' }, pl: 2 }}>
          <Typography variant="textSmall">
            Something went wrong. Please refresh the page.
          </Typography>
        </Box>
        <ButtonBase
          onClick={() => {
            setOpen(false);
            window.location.reload();
          }}
          sx={{
            ml: 1,
            alignSelf: 'center',
            px: '12px',
          }}
        >
          <Typography
            variant="textSmallBold"
            sx={{
              color: 'reds.dark',
              lineHeight: 1.5,
            }}
          >
            Refresh
          </Typography>
        </ButtonBase>
        <ButtonBase onClick={() => setOpen(false)} sx={{ px: 1 }}>
          <CloseIcon sx={{ fontSize: '20px', color: 'neutral.dark' }} />
        </ButtonBase>
      </Box>
    </Snackbar>
  );
};
